import fetch from '@/fetch'
import { Debounce, getByPath } from '@/utils'

const ReplaceVariables = (value, data) => {
  let m
  while ((m = value.match(/{(.+?)}/))) {
    let [, variable] = m
    value = value.replace(new RegExp(`{${variable}}`), getByPath(variable, data))
  }

  return value
}

const check = Debounce((rawUrl, value, passes) => {
  if (!rawUrl.match(/https?:\/{2}/)) rawUrl = window.location.origin + rawUrl
  let url = new URL(rawUrl)
  url.searchParams.append('value', value)

  return fetch(url.toString())
    .then(() => passes())
    .catch(res => res.text().then(msg => passes(false, msg)))
}, 300)

export default Validator => {
  Validator.registerAsync('request', function (data, attribute, req, passes) {
    let url = ReplaceVariables(attribute, this.validator.input)
    check(url, data, passes)
  })
}
